import React, { useEffect } from 'react'
import queryString from 'query-string'

const ClickLink = ({ history, match, addHistoryClick }) => {
  useEffect(() => {
    loadData()
  }, [])

  const loadData = async () => {
    const decodedSearch = queryString.parse(history.location.search)
    const { token } = match.params
    addHistoryClick(token, decodedSearch.redirectLink)
    window.open(decodedSearch.redirectLink, '_self')
  }

  return <div></div>
}

export default ClickLink
